__turbopack_context__.v({
  "description": "SuggestionCard-module__cCU_Wa__description",
  "suggestionCard": "SuggestionCard-module__cCU_Wa__suggestionCard",
  "titleContainer": "SuggestionCard-module__cCU_Wa__titleContainer",
});
